// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"002ca1be","787":"8b69e0f4","850":"5773ba83"}[chunkId] + ".chunk.js";
};